import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { useLocation } from '@grandvisionhq/frk-routing';
import { useBrPageContext } from '../../context/context.js';
import '@bloomreach/react-sdk';
import '../../context/configuration.js';
import '@bloomreach/spa-sdk';
import '@grandvisionhq/search';
import 'jsonpointer';
import '@grandvisionhq/utils';
import { getPageSeo } from '../../utils/get-page-seo.js';
import '@grandvisionhq/common';
import '../../utils/http-client.js';
import CmsHeadTags from '../HeadTags/HeadTags.js';

const CmsSeo = ()=>{
    var ref;
    const { query  } = useLocation();
    var ref1;
    const pageNum = Number((ref1 = query.get('page')) !== null && ref1 !== void 0 ? ref1 : 1);
    const page = useBrPageContext();
    const preview = page === null || page === void 0 ? void 0 : page.isPreview();
    const pageSeo = getPageSeo(page);
    if (!pageSeo && !preview) {
        return null;
    }
    return /*#__PURE__*/ React.createElement(React.Fragment, null, preview && /*#__PURE__*/ React.createElement("div", {
        style: {
            border: '2px solid black',
            padding: 10
        }
    }, "SEO configuration"), pageSeo && /*#__PURE__*/ React.createElement(CmsHeadTags, swcHelpers.extends({}, pageSeo, {
        ogUrl: pageSeo.canonicalUrl,
        noFollow: pageSeo.nofollow,
        noIndex: pageSeo.noindex,
        ogImage: ((ref = pageSeo.image) === null || ref === void 0 ? void 0 : ref.url) || '',
        pageNr: pageNum
    })));
};

export { CmsSeo, CmsSeo as default };
//# sourceMappingURL=Seo.js.map
